import {ChangeDetectionStrategy, Component, computed, inject, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatDialog, MatDialogModule} from '@angular/material/dialog'; // <-- AÑADIDO AQUÍ
import {ClpFormatPipe} from '@shared/pipes/clp/clp-format-pipe';
import {ConfirmCancelDialog} from './confirm-cancel-dialog/confirm-cancel-dialog';
import {CatalogStore} from '@store/catalog.store';
import {SessionStore} from '@store/session.store';
import {BillResponse} from '@core/models';
import {
  LucideCookingPot,
  LucideDollarSign,
  LucideFileText,
  LucideFrown,
  LucideHandPlatter,
  LucideHash,
  LucideReceipt,
  LucideTrash
} from '@lucide/angular';
import {TrackingWebsocket} from '@services/websockets/traking-websocket';

@Component({
  selector: 'app-tracking',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule, // <-- AÑADIDO AQUÍ
    ClpFormatPipe,
    LucideReceipt,
    LucideTrash,
    LucideDollarSign,
    LucideCookingPot,
    LucideHandPlatter,
    LucideFileText,
    LucideFrown,
    LucideHash,
  ],
  templateUrl: './tracking.html',
  styleUrl: './tracking.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Tracking implements OnInit, OnDestroy {
  protected readonly store = inject(CatalogStore);
  protected readonly sessionStore = inject(SessionStore);
  protected readonly wsService = inject(TrackingWebsocket);
  private readonly dialog = inject(MatDialog);

  private readonly trackingSource = computed(() =>
    (this.sessionStore.orderDetails()) as BillResponse
  );

  totalAmount = computed(() => {
    const data = this.trackingSource()?.details || [];
    return data.reduce((acc: number, item: any) => acc + (item.price * item.quantity), 0);
  });

  ownOrders = computed(() => {
    const data = this.trackingSource()?.details || [];
    const currentCustomer = this.sessionStore.customerId();
    return data.filter((c: any) => c.customerId === currentCustomer);
  });

  amount = computed(() => {
    const data = this.trackingSource()?.details || [];
    const currentCustomer = this.sessionStore.customerId();
    return data
      .filter((c: any) => c.customerId === currentCustomer)
      .reduce((acc: number, item: any) => acc + (item.price * item.quantity), 0);
  });

  ngOnInit() {
    this.store.setBackRoute('/standard/categories');
    this.store.setHeaderTitle('Seguimiento');
    this.sessionStore.loadOrderStatusSession();

    // Se asegura la reconexión al WebSocket al inicializar la pantalla si existen credenciales de sesión activa
    const orderId = sessionStorage.getItem('current_order_id');
    const customerId = sessionStorage.getItem('current_customer_id');

    if (orderId && customerId) {
      this.wsService.connect(orderId, customerId);
    }
  }

  ngOnDestroy() {
    // Cierre explícito del canal WebSocket al destruir el componente para evitar fugas de memoria
    this.wsService.close();
  }

  cancelProduct(item: any) {
    if (item.customerId !== this.sessionStore.customerId()) return;

    const dialogRef = this.dialog.open(ConfirmCancelDialog, {
      width: '350px',
      data: {
        icon: 'warning',
        title: 'Confirmar Cancelación',
        titleColor: 'warn-title-danger',
        productName: item.product,
        clazz: 'action-btn btn-danger',
        textButon: 'Eliminar',
        isWarning: true,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sessionStore.cancelProduct({
          orderProductId: item.productId,
          onSuccess: () => {
            this.sessionStore.loadOrderStatusSession();
          },
          onError: (err: any) => console.error('Error al cancelar', err)
        });
      }
    });
  }

  requestBill() {
    const dialogRef = this.dialog.open(ConfirmCancelDialog, {
      width: '90%',
      maxWidth: '400px',
      data: {
        icon: 'info',
        title: '¿Deseas pedir la cuenta?',
        titleColor: 'warn-title-success',
        productName: 'Se notificará al garzón para traer la boleta.',
        confirmText: 'PEDIR CUENTA',
        isWarning: false,
        clazz: 'action-btn btn-success',
        textButon: 'Aceptar',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sessionStore.requestFinalBill({
          onSuccess: () => {
            this.sessionStore.loadOrderStatusSession();
          },
          onError: (err) => {
            console.error('Error de negocio detectado al pedir la cuenta:', err);
            this.sessionStore.loadOrderStatusSession();
          }
        });
      }
    });
  }

  protected callWaiter() {
    this.sessionStore.callWaiter({
      onSuccess: () => {
      },
      onError: (err) => console.error('Error al llamar al garzón', err)
    });
  }
}
